import { z } from 'zod';
import { Button } from '../Button/Button';
import { Form, useForm } from '../ui/Form';

interface EmailFormProps {
  onSubmit: (value: { email: string }) => void;
  isLoading?: boolean;
}

const EmailForm = ({ onSubmit, isLoading }: EmailFormProps) => {
  const form = useForm({
    schema: z.object({
      email: z.string(),
    }),
  });
  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col gap-3"
      >
        <input
          {...form.register('email')}
          type="email"
          placeholder="Email"
          className="font-medium border-2 border-border2 rounded-xl px-4 p-2 h-11 focus:outline-none placeholder:text-textGray3 focus:border-blue"
          required
        />

        <Button
          // disabled={true}
          isLoading={isLoading}
          size="lg"
          className="hover:scale-[1.02] transition-all"
          type="submit"
        >
          Continue with email
        </Button>
        {/* <p className="text-sm text-red">
          Log in with email is temporarily unavailable.
        </p> */}
      </form>
    </Form>
  );
};

export default EmailForm;
